﻿// © Microsoft Corporation. All rights reserved.

import { IActionDispatchCancellationToken } from "./IActionDispatchCancellationToken";

/**
 * Cancellation Token class.
 * @class
 */
export class ActionDispatchCancellationToken implements IActionDispatchCancellationToken {
   /** Backing variable for the isCancellationRequested property
    * @type {boolean}
    */
    private isCancelled: boolean;

    /**
     * Creates an instance of the `ActionDispatchCancellationToken` class.
     * @constructor
     */
    constructor() {
        this.isCancelled = false;
    }

   /**
    * Helper method to cater for a null or undefined token.
    * A null or undefined token means cancellation cannot be requested, so it is equivalent to false
    * @method
    * @param {IActionDispatchCancellationToken} cancellationToken Optional cancellation token to be checked for undefined, null or cancellation requested
    * @returns {boolean}
    */
    public static isCancellationRequested(cancellationToken?: IActionDispatchCancellationToken): boolean {
        return !(cancellationToken === undefined || cancellationToken === null || !cancellationToken.isCancellationRequested);
    }

    /** The cancel method.
     * @method
     */
    public cancel(): void {
        this.isCancelled = true;
    }

    /** getter for the isCancellationRequested property
     * @property
     * @returns {boolean} Whether cancellation has been requested or not.
     */
    public get isCancellationRequested(): boolean {
        return this.isCancelled;
    }
}